import { render, staticRenderFns } from "./DisplayGallery.vue?vue&type=template&id=22c5060e&scoped=true&lang=html&"
import script from "./DisplayGallery.vue?vue&type=script&lang=js&"
export * from "./DisplayGallery.vue?vue&type=script&lang=js&"
import style0 from "./DisplayGallery.vue?vue&type=style&index=0&id=22c5060e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5060e",
  null
  
)

export default component.exports